const sessionKey = 'new_support_issue'

export interface WizardData {
  categoryId: string | undefined
  issueId: string | undefined
  setId: string | undefined
  content: string
	email: string   
	phoneNumber: string | undefined 
}

const ID = (): string => {
  return sessionKey
}

export const LoadWizardData = (): WizardData => {
  var json = sessionStorage.getItem(ID())
  if (!json) {
    return CleanWizardData()
  }
  const data = JSON.parse(json)
  return {
    categoryId: data.categoryId,
    issueId: data.issueId,
    content: data.content || '',
    setId: data.setId,
    email: data.email,
    phoneNumber: data.phoneNumber
  }
}

export const SaveWizardData = (data: WizardData) => {
  sessionStorage.setItem(ID(), JSON.stringify(data))
}

export const CleanWizardData = (): WizardData => {
  var empty: WizardData = {
    categoryId: undefined,
    issueId: undefined,
    content: '',
    setId: undefined,
    email: '',
    phoneNumber: undefined
  }
  SaveWizardData(empty)
  return empty
}

interface Issue {
  id: string
}

interface Category {
  id: string
  issues: Issue[]
}

export const categories: Category[] = [{
  id: "gps",
  issues: [
    {id: "startup_err"},
    {id: "led_signal"},
    {id: "gps_can_err"},
    {id: "gps_data_err"},
    {id: "gps_other"}
  ]
}, {
  id: "qrcode",
  issues: [
    {id: "page_not_displaying"},
    {id: "app_malfunctions"},
    {id: "report_faults_err"},
    {id: "no_documentation"}
  ]
}, {
  id: "app",
  issues: [
    {id: "website_not_working"},
    {id: "login_err"},
    {id: "no_data"},
    {id: "no_raports"},
    {id: "incorrect_data"}
  ]
}, {
  id: "bem",
  issues: [
    {id: "not_starting"},
    {id: "damaged_connector"},
    {id: "damaged_mounting"},
    {id: "led_indicator"},
    {id: "dongle_err"}
  ]
}, {
  id: "bqs_charger",
  issues: [
    {id: "damaged_cables"},
    {id: "traffic_lights"},
    {id: "missing_leds"},
    {id: "damaged_mounting"}
  ]
}, {
  id: "bqs_cabinet",
  issues: [
    {id: "unable_to_start"},
    {id: "Visualization_err"},
    {id: "other"}
  ]
}]